<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-2 py-lg-2 pt-lg-2">
      <div class="container">
        <div class="header-body text-center mb-6">
        </div>
      </div>
    </div>

    <div class="container mt-4 mb-6">
      <div class="row">
        <div class="col-3">
          <InfoMenu/>
        </div>
        <div class="col-9">
          <h2>Контакты</h2>
          <p><b>Контакты:</b></p>
          <p>Фактический адрес: 127006, г. Москва, ул. Садовая-Триумфальная, д. 18, стр. 4</p>
          <p>Электронная почта: info@komandor.app</p>
          <p>Телефон: +7 495 643-89-89, +7 495 694-62-86</p>
          <p></p>
          <p><b>Реквизиты:</b></p>
          <p>ООО "Командор"</p>
          <p>ИНН 7710862988, ОГРН 1107746111164</p>
          <p>Юридический адрес: 127006, г. Москва, ул. Садовая-Триумфальная, д. 18, стр. 4</p>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
  import InfoMenu from './Menu'
  export default {
    name: 'InfoContacts',
    components: { InfoMenu }
  }
</script>
<style></style>
